import apiService from './ApiService';

class AdminMonitorService {
  async getSnapshot() {
    return apiService.get('/AdminMonitor/snapshot');
  }
}

const adminMonitorService = new AdminMonitorService();
export default adminMonitorService;
